import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import {
  INQUIRY_PROCESS_NAME,
  resolveLatestProcessName,
} from '../../transactions/transaction';

import { Heading, IconSpinner, Modal } from '../../components';
import UserCard from './UserCard/UserCard';
import InquiryForm from './InquiryForm/InquiryForm';

import css from './ListingPage.module.css';

const SectionAuthorMaybe = props => {
  const {
    title,
    listing,
    authorDisplayName,
    onContactUser,
    isInquiryModalOpen,
    onCloseInquiryModal,
    sendInquiryError,
    sendInquiryInProgress,
    onSubmitInquiry,
    currentUser,
    onManageDisableScrolling,
    customImage,
    customLinkProps,
    makerListing,
    fetchMakerListingError,
    fetchMakerListingInProgress,
  } = props;

  if (
    !listing.author ||
    fetchMakerListingError ||
    (!fetchMakerListingInProgress && !makerListing)
  ) {
    return null;
  }

  if (fetchMakerListingInProgress) {
    return <IconSpinner />;
  }

  const makerListingId = makerListing?.id?.uuid;
  const makerName = makerListing?.attributes?.title || '';
  const makerImage = makerListing?.images?.[0];
  const {description: makerDescription} = makerListing?.attributes || {}
  
  const makerListingLinkProps = {
    name: 'MakerListingPage',
    params: {
      makerListingId,
    },
  };

  const transactionProcessAlias =
    listing?.attributes?.publicData?.transactionProcessAlias || '';
  const processName = resolveLatestProcessName(
    transactionProcessAlias.split('/')[0]
  );
  const isInquiryProcess = processName === INQUIRY_PROCESS_NAME;

  return (
    <div id="author" className={css.sectionAuthor}>
      <Heading as="h2" rootClassName={css.sectionHeadingWithExtraMargin}>
        <FormattedMessage id="ListingPage.aboutProviderTitle" />
      </Heading>
      <UserCard
        user={listing.author}
        currentUser={currentUser}
        onContactUser={onContactUser}
        showContact={!isInquiryProcess}
        customImage={makerListing ? makerImage : customImage}
        authorDisplayName={makerListing ? makerName : authorDisplayName}
        customLinkProps={makerListing ? makerListingLinkProps : customLinkProps}
        authorDescription={makerDescription}
      />
      <Modal
        id="ListingPage.inquiry"
        contentClassName={css.inquiryModalContent}
        isOpen={isInquiryModalOpen}
        onClose={onCloseInquiryModal}
        usePortal
        onManageDisableScrolling={onManageDisableScrolling}
      >
        <InquiryForm
          className={css.inquiryForm}
          submitButtonWrapperClassName={css.inquirySubmitButtonWrapper}
          listingTitle={title}
          authorDisplayName={authorDisplayName}
          sendInquiryError={sendInquiryError}
          onSubmit={onSubmitInquiry}
          inProgress={sendInquiryInProgress}
        />
      </Modal>
    </div>
  );
};

export default SectionAuthorMaybe;
